import React, { Component } from 'react';
import Modal from '../../../../../modal/rendu';
import styles, { raw } from './style';
import { Text } from 'react-native-web';
import ModalPage from './page/rendu';
import { Button } from 'react-bootstrap';

export default class ModalTableau extends Component {
  constructor (props) {
    super(props);
    this.state = {
      isVisible: true,
      indicePage: null,
      actuel: this.props.tableau
        ? this.props.tableau.map(() => {
          return {
            ouvrage: null,
            programme: null,
            priorite: null,
            pylone: null
          };
        })
        : null
    };
  }

  shouldComponentUpdate (nextProps, nextState, nextContext) {
    if (nextProps.tableau !== this.props.tableau && nextProps.tableau) {
      this.setState({
        actuel: nextProps.tableau
          ? nextProps.tableau.map(() => {
            return {
              ouvrage: null,
              programme: null,
              priorite: null,
              pylone: null
            };
          })
          : [],
        indicePage:
          nextProps.tableau && nextProps.tableau.length === 1 ? 0 : null
      });
    }

    return true;
  }

  render () {
    return [
      <Modal
        validationDisabled={
          !this.props.tableau ||
          this.props.tableau.length === 0 ||
          !this.state.actuel ||
          this.state.actuel.reduce((valPrecedent, valActuel) => {
            return (
              (valActuel.ouvrage === null ||
                valActuel.priorite === null ||
                valActuel.programme === null ||
                valActuel.pylone === null) &&
              valPrecedent
            );
          }, true)
        }
        isVisible={
          this.state.isVisible &&
          this.props.isVisible &&
          this.props.tableau &&
          this.props.tableau.length > 1
        }
        onValidate={() => {
          if (typeof this.props.onValidate === 'function') {
            this.props.onValidate(this.state.actuel);
          }
        }}
        titre={'Pages'}
        onCancel={this.props.onCancel}>
        {this.props.tableau
          ? this.props.tableau.map((val, indice) => {
            return (
                  <Button
                    variant={'dark'}
                    style={raw.bouton}
                    onClick={() => {
                      this.setState({ indicePage: indice, isVisible: false });
                    }}>
                    <Text style={styles.boutonTexte}>
                      {val.nom ? val.nom : `Page ${indice + 1}`}
                    </Text>
                  </Button>
            );
          })
          : null}
      </Modal>,
      <ModalPage
        unique={this.props.tableau && this.props.tableau.length === 1}
        isVisible={
          this.state.actuel && typeof this.state.indicePage === 'number'
        }
        actuel={
          this.state.actuel && typeof this.state.indicePage === 'number'
            ? this.state.actuel[this.state.indicePage]
            : null
        }
        page={
          this.props.tableau &&
          this.state.actuel &&
          typeof this.state.indicePage === 'number'
            ? this.props.tableau[this.state.indicePage].feuille
            : null
        }
        onValidate={element => {
          this.state.actuel[this.state.indicePage] = element;

          if (this.props.tableau.length === 1 && typeof this.props.onValidate === 'function') {
            this.props.onValidate(this.state.actuel);
          }
        }}
        onCancel={() => {
          if (this.props.tableau.length === 1 && typeof this.props.onCancel === 'function') {
            this.props.onCancel();
          }
        }}
        onHide={() => {
          this.setState({
            indicePage: null,
            isVisible: true
          });
        }}
      />
    ];
  }
}
